import React from "react";
import { withStyles } from "@material-ui/core";
import { compose } from "recompose";
import {
  totalValueGetter,
  returnCustomerName,
} from "../NextStopComplianceUtills";
import Tooltip from "../../../../common/StyledToolTip";
import appConstants from "../../../../../appConstants";
import StopInfoField from "./StopInfoField";
import { formatDeliveryOrServiceWindow } from "../../../Dispatch/utils/utils";

const styles = (theme) => ({
  headerText: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    color: theme.iconColor,
    lineHeight: "21px",
    margin: "19px 0px 10px 0px",
  },
  subHeaderText: {
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    padding: "5px 0px 0px 28px",
    minWidth: "fit-content",
  },
  subHeaderTextBold: {
    fontWeight: "600",
    fontSize: theme.textFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    padding: "5px 0px 0px 5px",
  },
  redHeader: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    color: theme.deviationStopPopupColor,
  },
  leftPadding: {
    paddingLeft: "10px",
  },
  greenHeader: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "22px",
    color: theme.ToggleIconColor,
  },
  ellipsisText: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "80%",
  },
  flexRow: {
    display: "flex",
  },
  moreText: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.palette.primary.main,
  },
});

const StopInfo = ({
  classes,
  stopDetails,
  manifestNumber,
  isDeviation,
  stopLabel,
}) => {
  const customerName = returnCustomerName(stopDetails.data);
  
  const renderTruncatedValue = (items) => {
    if (!items.length) return null;
    
    const fullText = items.join(", ");
    if (items.length <= 2) {
      return <div className={classes.subHeaderTextBold}>{fullText}</div>;
    }
    
    return (
      <Tooltip title={<div>{fullText}</div>}>
        <div className={classes.subHeaderTextBold}>
          {`${items.slice(0, 2).join(', ')} `}
          <span className={classes.moreText}>+{items.length - 2} more</span>
        </div>
      </Tooltip>
    );
  };

  const getProNumberString = (data) => {
    const proIds = data?.shipments?.map((s) => s.proId)?.filter(Boolean) || [];
    return renderTruncatedValue(proIds);
  };

  const getPickupNumberString = (data) => {
    const pickupNumbers = data?.shipments?.map((s) => s.pickupNumber).filter(Boolean) || [];
    return renderTruncatedValue(pickupNumbers);
  };

  let loadingZones = [
    ...new Set(
      stopDetails.data.shipments.reduce((previousValue, currentValue) => {
        return currentValue.loadingZone
          ? [...previousValue, currentValue.loadingZone]
          : [...previousValue];
      }, [])
    ),
  ];
  
  return (
    <React.Fragment>
      <div className={classes.headerText}>{stopLabel}</div>
      <div className={classes.flexRow}>
        <div className={isDeviation ? classes.redHeader : classes.greenHeader}>
          {stopDetails.stopSequence}
          {stopDetails.data.stopType === appConstants.STOP_TYPE.Delivery
            ? "D"
            : "P"}
        </div>
        <Tooltip title={<div>{customerName}</div>}>
          <div
            className={`${
              isDeviation ? classes.redHeader : classes.greenHeader
            } ${classes.leftPadding} ${classes.ellipsisText}`}
          >
            {customerName}
          </div>
        </Tooltip>
      </div>
      <div className={classes.flexRow}>
        <div className={classes.subHeaderText}>Pro ID:</div>
        {getProNumberString(stopDetails.data)}
      </div>

      {loadingZones.length > 0 && (
        <StopInfoField
          classes={classes}
          fieldName="Loading Zone"
          fieldValue={loadingZones.join(", ")}
        ></StopInfoField>
      )}
      {stopDetails.data.stopType === appConstants.STOP_TYPE.Pickup && (
        <div className={classes.flexRow}>
          <div className={classes.subHeaderText}>Pickup Number:</div>
          {getPickupNumberString(stopDetails.data)}
        </div>
      )}
      {stopDetails.data.receiverName && (
        <StopInfoField
          classes={classes}
          fieldName="Receiver"
          fieldValue={stopDetails.data.receiverName}
        ></StopInfoField>
      )}
      <StopInfoField
        classes={classes}
        fieldName="Manifest No"
        fieldValue={manifestNumber}
      ></StopInfoField>
      <StopInfoField
        classes={classes}
        fieldName="Address"
        fieldValue={stopDetails.data.address}
      ></StopInfoField>
      <div className={classes.flexRow}>
        <div className={classes.subHeaderText}>Weight :</div>
        <div className={classes.subHeaderTextBold}>
          {totalValueGetter(stopDetails.data, "weight")}
        </div>
        <div className={classes.subHeaderText}> PSE :</div>
        <div className={classes.subHeaderTextBold}>
          {totalValueGetter(stopDetails.data, "pse")}
        </div>
        <div className={classes.subHeaderText}> HU :</div>
        <div className={classes.subHeaderTextBold}>
          {totalValueGetter(stopDetails.data, "hu")}
        </div>
      </div>

      <StopInfoField
        classes={classes}
        fieldName={
          stopDetails.data.stopType === appConstants.STOP_TYPE.Delivery
            ? "Delivery Window"
            : "Pickup Window"
        }
        fieldValue={formatDeliveryOrServiceWindow(stopDetails.data.serviceWindow)}
      ></StopInfoField>
      <StopInfoField
        classes={classes}
        fieldName="Arrival Time"
        fieldValue={stopDetails.arrivalTime}
      ></StopInfoField>
      <StopInfoField
        classes={classes}
        fieldName="Departure Time"
        fieldValue={stopDetails.departureTime}
      ></StopInfoField>
      {stopDetails.data.priority && (
        <StopInfoField
          classes={classes}
          fieldName="Priority"
          fieldValue={stopDetails.data.priority}
        ></StopInfoField>
      )}
    </React.Fragment>
  );
};
export default compose(withStyles(styles))(StopInfo);
